// extracted by mini-css-extract-plugin
export default {"grid":"BacktestsPage_grid__jtetv","toolbar":"BacktestsPage_toolbar__iYEFL","flex":"BacktestsPage_flex__vx1W-"};